import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "./component/homepage";
import MachinePage from "./component/machinesPage";
import SalesPage from "./component/salesPage";
import InventoryPage from "./component/InventoryPage";
import MaintenancePage from "./component/maintenancePage";
import UsersPage from "./component/usersPage";
import AddUserPage from "./component/addUserPage";
import LoginPage from "./component/login";
import TransactionPage from "./component/transactionPage";
import AddDeviceUserPage from "./component/addDeviceUserPage";
import DeviceUsersListPage from "./component/deviceUsersListPage";
import LogoPage from "./component/LogoPage";
import DeviceErrorsPage from "./component/DeviceErrorsPage";
import AdvertisementPage from "./component/advertisementPage";
import FlavorsPage from "./component/FlavorsPage";

import ForgotPassword from "./component/ForgotPassword";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/homePage" element={<HomePage />} />
        <Route path="/machinePage" element={<MachinePage />} />
        <Route path="/salesPage" element={<SalesPage />} />
        <Route path="/inventoryPage" element={<InventoryPage />} />
        <Route path="/maintenancePage" element={<MaintenancePage />} />
        <Route path="/flavorsPage" element={<FlavorsPage />} />
        <Route path="/usersPage" element={<UsersPage />} />
        <Route path="/addUser" element={<AddUserPage />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/transactionPage" element={<TransactionPage />} />
        <Route path="/deviceUsers" element={<DeviceUsersListPage />} />
        <Route path="/addDeviceUser" element={<AddDeviceUserPage />} />
        <Route path="/logoSettings" element={<LogoPage />} />
        <Route path="/deviceErrors" element={<DeviceErrorsPage />} />
        <Route path="/advertisementPage" element={<AdvertisementPage />} />

      </Routes>
    </BrowserRouter>
  );
}
